import DBR from "dynamsoft-javascript-barcode";

/** LICENSE ALERT - THE END */
DBR.organizationID = "100838422";
DBR.handshakeCode = "100838422-100839496";

DBR.BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@8.8.7/dist/";
DBR.BarcodeReader._onLog = console.log;
export default DBR;